import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 py-6">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} AMA-Europe. Všechna práva vyhrazena.
          </div>
          <div className="flex space-x-4 mt-2 md:mt-0">
            <a href="/privacy" className="text-gray-300 hover:text-blue-400 transition-colors">
              Ochrana osobních údajů
            </a>
            <a href="/terms" className="text-gray-300 hover:text-blue-400 transition-colors">
              Podmínky použití
            </a>
            <a href="/contact" className="text-gray-300 hover:text-blue-400 transition-colors">
              Kontakt
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 